import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import CSSModules from 'react-css-modules';
import classNames from 'classnames';
import {FormattedMessage} from 'react-intl';
import * as FormatUtils from 'utils/formatUtils';
import * as paymentConstants from 'constants/paymentConstants';
import styles from './payments.scss';
import NumberFormatter from '../../utils/numberFormatter';

@CSSModules(styles, {allowMultiple: true})
class Payments extends React.Component {
  static propTypes = {
    data: PropTypes.array.isRequired
  };

  constructor(props) {
    super(props);
  }

  isUnschduled(payment) {
    return paymentConstants.unscheduledTypes.indexOf(payment.type) >= 0;
  }

  componentDidMount() {
    // center to the next payment
    const paymentsElem = ReactDOM.findDOMNode(this);
    const nextPaymentElem = this.refs['payment_next'];
    if (nextPaymentElem) {
      paymentsElem.scrollLeft = (nextPaymentElem.offsetLeft - (paymentsElem.offsetWidth/2 - nextPaymentElem.offsetWidth/2));
    }
  }

  renderPayment(payment, index) {
    const isUnscheduled = this.isUnschduled(payment);
    const className = classNames(styles.payment, styles[payment.status.toLowerCase()], {[styles.unscheduled]: isUnscheduled});

    const renderTop = isUnscheduled ?
      <div styleName="paymentTop"><FormattedMessage id="payNow.payments.payment.manual" /></div> :
      <div data-at="paymentOrdinal" styleName="paymentTop">{NumberFormatter.ordinalFormat(payment.ordinalIndex)}</div>;

    return (
      <div data-at="paymentContainer" className={className} key={index} ref={`payment_${payment.status === 'next' ? 'next' : index}`}>
        {renderTop}
        <div data-at="paymentAmount" styleName="paymentAmount">{FormatUtils.addPriceSymbol(payment.amount)}</div>
        <div data-at="paymentDate" styleName="paymentDate">{FormatUtils.transformDate(payment.dueDate)}</div>
      </div>
    );
  }

  render() {
    const className = classNames('payments');
    const payments = this.props.data.filter((payment) => {
      return payment.amount > 0 && payment.type !== paymentConstants.PAYMENT_TYPE_DOWN_PAYMENT;
    });

    payments.some((payment) => {
      if(payment.status === 'next') {
        return true;
      }
      if (payment.status === 'PENDING') {
        payment.status ='next';
        return true;
      }
    });

    let ordinalIndex = 0;
    payments.forEach((payment) => {
      if (!this.isUnschduled(payment)) {
        ordinalIndex++;
        payment.ordinalIndex = ordinalIndex;
      }
    });

    return (
      <div styleName="paymentsWrap">
        <div styleName={className}>
          {
            payments.map((payment, index) => {
              return this.renderPayment(payment, index);
            })
          }
        </div>
      </div>
    );
  }
}


export default Payments;



// WEBPACK FOOTER //
// ./src/components/payments/Payments.js